import styled, { css } from 'styled-components';
import { LikeDislikeStyledProps, LikeDislikeStyledInlineProps } from '../../../types';

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled(Flex)`
  align-items: stretch;
  padding-top: 30px;
  margin: 0 16px 20px 16px;
  padding: 26px 29px;
  background: #f8f8f8;
  width: 100%;
`;

const ContainerFeedback = styled(Flex)<LikeDislikeStyledInlineProps>`
  margin-left: 30px;
  color: ${({ theme }) => theme.grey.dark};
  font-size: 16px;
  font-weight: bold;
  flex-direction: column;
  width: 25%;
  border-left: 1px solid ${({ theme }) => theme.grey.light};

  ${({ inLine }) =>
    inLine &&
    css`
      width: 100%;
      margin-left: 0px;
      flex-direction: row;
      border: none;
      justify-content: start;
    `}
`;

const Like = styled.div<LikeDislikeStyledProps>`
  width: 26px;
  stroke: ${({ theme, userFeedback }) => (userFeedback ? theme.buttonLikeColor : theme.grey.dark)};
`;

const Unlike = styled(Like)`
  transform: rotate(180deg);
  stroke: ${({ theme, userFeedback }) => (userFeedback ? theme.buttonDislikeColor : theme.grey.dark)};
`;

const ActionRecommendation = styled.button`
  display: flex;
  background: transparent;
  border: 0;
  padding: 0px 10px;
  align-items: center;
  outline: none;
  cursor: pointer;
`;

const LabelRecommendation = styled.span`
  color: ${({ theme }) => theme.grey.dark};
  margin-left: 8px;
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const RecommendationText = styled.span<LikeDislikeStyledInlineProps>`
  padding-bottom: 10px;
  font-size: ${({ theme }) => theme.fontSize.lg};

  ${({ inLine }) =>
    inLine &&
    css`
      font-family: Arial;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;

      display: flex;
      color: #666666;
      padding: 0px;
    `}
`;

export {
  ActionRecommendation,
  ContainerFeedback,
  Flex,
  LabelRecommendation,
  Like,
  RecommendationText,
  Unlike,
  Wrapper,
};
